import type { VFC } from 'react'

interface AlternateLinkProps {
  /** Canonical URL (or path) of the current page; only its origin is used. */
  path: string
}

// Advertise the SITE feed, not a per-page `<canonical>feed` URL. The per-page form pointed
// crawlers at WordPress comment feeds via a 308 (`/slug/feed` → `/slug/feed/`), ~100k
// requests/day on AA alone, mostly from AI crawlers walking the archive. Nobody subscribes
// to per-article comment feeds; the site feed is what readers and aggregators actually use.
const siteFeedHref = (path: string): string => {
  try {
    return `${new URL(path).origin}/feed/`
  } catch {
    return '/feed/'
  }
}

const AlternateLink: VFC<AlternateLinkProps> = ({ path }) => (
  <link rel="alternate" type="application/rss+xml" href={siteFeedHref(path)} />
)

export default AlternateLink
